import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Award, Shield, CheckCircle } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const Certifications = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title={t('Πιστοποιήσεις', 'Certifications')}
        description={t(
          'Πιστοποιήσεις ποιότητας της TFT: ISO 9001, CE marking και άλλα πρότυπα για εξοπλισμό τροφίμων.',
          'TFT quality certifications: ISO 9001, CE marking and other standards for food equipment.'
        )}
        canonical="https://www.tft.gr/certifications"
      />
      <Navigation />

      <main>
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-b from-primary to-primary-light text-primary-foreground">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-5xl font-bold mb-6">{t('Πιστοποιήσεις & Βραβεία', 'Certifications & Awards')}</h1>
            <p className="text-xl max-w-3xl mx-auto opacity-90">
              {t('Αναγνωρισμένη αριστεία και πιστοποιημένη ποιότητα', 'Recognized excellence and certified quality')}
            </p>
          </div>
        </section>

        {/* Certifications */}
        <section className="py-20 bg-background">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto space-y-8">
              <Card>
                <CardContent className="p-8">
                  <div className="flex items-start">
                    <div className="mr-6 p-4 bg-primary/10 rounded-2xl">
                      <Shield className="h-12 w-12 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold mb-3">ISO 9001:2015</h3>
                      <p className="text-muted-foreground">
                        {t('Πιστοποίηση Συστήματος Διαχείρισης Ποιότητας που εγγυάται την υψηλή ποιότητα των υπηρεσιών και των προϊόντων μας.', 'Quality Management System Certification that guarantees the high quality of our services and products.')}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-8">
                  <div className="flex items-start">
                    <div className="mr-6 p-4 bg-primary/10 rounded-2xl">
                      <Award className="h-12 w-12 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold mb-3">{t('Πιστοποιημένοι Συνεργάτες', 'Certified Partners')}</h3>
                      <p className="text-muted-foreground">
                        {t('Επίσημοι αντιπρόσωποι κορυφαίων κατασκευαστών εξοπλισμού με πιστοποιημένη τεχνική υποστήριξη.', 'Official representatives of leading equipment manufacturers with certified technical support.')}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-8">
                  <div className="flex items-start">
                    <div className="mr-6 p-4 bg-primary/10 rounded-2xl">
                      <CheckCircle className="h-12 w-12 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold mb-3">{t('Βραβεία Αριστείας', 'Excellence Awards')}</h3>
                      <p className="text-muted-foreground">
                        {t('Αναγνώριση για την ποιότητα των έργων μας και την εξαιρετική εξυπηρέτηση πελατών από διεθνείς οργανισμούς.', 'Recognition for the quality of our projects and excellent customer service from international organizations.')}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Certifications;
